import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import QRForm from "./QRForm";
import QRList from "./QRList";

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("token")) navigate("/");
  }, []);

  return (
    <div>
      <h2>QR Dashboard</h2>
      <button onClick={() => {
        localStorage.removeItem("token");
        navigate("/");
      }}>Logout</button>

      <QRForm />
      <QRList />
    </div>
  );
}